<template>
  <div class="noprint">
    <v-container
      class="hidden-sm-and-down"
    >
      <v-layout wrap>
        <v-flex>
          <router-link to="/dashboard">
            <img 
              :height="imgHeight" 
              :src="logo" 
            />
          </router-link>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex text-xs-right v-if="token">
          <v-btn flat to="/profile">
            <strong>Hi! Doctor {{ user.lastname }}!</strong>
          </v-btn>
          <v-btn flat @click="logout">
            <strong>Log out</strong>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    
    <v-toolbar class="hidden-md-and-up">
      <v-toolbar-title>
        <img :src="logo" height="32" />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-if="token">
        <v-btn flat to="/profile">
          <strong>Hi! Doctor {{ user.lastname }}!</strong>
        </v-btn>
        <v-btn flat @click="logout">
          <strong>Log out</strong>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
import {getUser, deleteUser, deleteAuthToken, getAuthToken} from '@/utils/token'
export default {
  data () {
    return {
      imgHeight: 128,
      logo: require('@/assets/svg/ELITE Logo.svg')
    }
  },
  computed: {
    user () {
      return getUser()
    },
    token () {
      return getAuthToken()
    }
  },
  methods: {
    logout () {
      deleteUser()
      deleteAuthToken()
      this.$router.push('/')
    }
  }
}
</script>
<style type="text/css" media="print">
  @media print
  {
    .noprint {display:none;}
  }
</style>


// WEBPACK FOOTER //
// src/components/dashboard/dashboardHeader.vue